
































import Vue from "vue";
import vClickOutside from "v-click-outside";
import BaseModalWindow from "@/app/shared/components/base/BaseModalWindow.vue";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";

export default Vue.extend({
  name: "BaseConfirmInline",
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: { BaseModalWindow, BaseButton },
  data: function () {
    return {
      loaded: false,
    };
  },
  props: {
    message: {
      type: String,
      required: true,
    },
    acceptTitle: {
      type: String,
      default: "Yes",
    },
    discardTitle: {
      type: String,
      default: "No",
    },
    needCloseClickOutside: {
      type: Boolean,
      default: true,
    },
  },
  computed: {},
  created() {},
  mounted() {
    this.loaded = true;
  },
  watch: {},
  methods: {
    accept() {
      this.$emit("accept");
      this.close();
    },
    discard() {
      this.$emit("discard");
      this.close();
    },
    close() {
      this.loaded = false;
      setTimeout(() => {
        this.$emit("close");
      }, 200);
    },
    clickOutside() {
      if (this.needCloseClickOutside) {
        this.close();
      }
    },
  },
});
